// src/api/apiContext.js
import React, { createContext } from 'react';
import api from './api';

export const ApiContext = createContext(api);

export const ApiProvider = ({ children }) => {
  return (
    <ApiContext.Provider value={api}>
      {children}
    </ApiContext.Provider>
  );
};